import BreadCumb from "../Components/Common/BreadCumb";
import KYC from "../Components/KYC/KYC";

const KYCPage = () => {
    return (
        <div>
            <BreadCumb
                bgimg="/assets/images/bg/breadcumgBg.png"
                Title="Know Your Customer (KYC)"
            ></BreadCumb>
            <KYC></KYC>
        </div>
    );
};

export default KYCPage;
